import actionTypes from '../actionTypes';

export function successJoinToRace(payload?: any) {
  return {
    type: actionTypes.JOIN_TO_RACE_SUCCESS,
    payload,
  };
}

export function failJoinToRace(e: any) {
  return {
    type: actionTypes.JOIN_TO_RACE_FAILURE,
    exception: e,
  };
}

export function updateJoinToRacePendingStatus() {
  return {
    type: actionTypes.UPDATE_JOIN_TO_RACE_PENDING_STATUS,
  };
}
